/** 76×51 mm (3×2 in) label at 203 dpi (609 × 406 dots). */
export const LABEL_76X51_203DPI = {
  id: "76x51" as const,
  widthIn: 3,
  heightIn: 2,
  dpi: 203,
  widthDots: 609,
  heightDots: 406,
  margin: 16,
  label: "76 × 51 mm",
  recommendedUse: "Default · all labels",
} as const;